import { render } from "./HomeCategoryList.vue?vue&type=template&id=04d2de3a"
import script from "./HomeCategoryList.vue?vue&type=script&lang=js"
export * from "./HomeCategoryList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\mli\\JTX\\ichioshiSO\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__